import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import FoodcompositionDashboard from '../FoodcompositionDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import FoodcompositionPageImpl from './FoodcompositionPageImpl';

export default function FoodcompositionPage() {
    const dispatch = useDispatch();
    const { foodcompositionList} = useSelector((state)=>state.pharmaslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < FoodcompositionPageImpl />
    )

}